/**
 * VP FlightsHotel + fixed "+" markup: display total normally sums selected-room PWCC.
 * While search multi-room slots are only partially selected, that under-prices the package
 * (e.g. 2-room search with 1 room selected → 1× price). Prefer the compose PWCC until every
 * slot has a billable room; once complete, keep the selected-room sum (agent upgrades).
 *
 * @param {{
 *   summedRoomPwccIls: number,
 *   composedPwccIls: number|null|undefined,
 *   slotsLength: number,
 *   includedCount: number,
 *   hasManualAddedRooms?: boolean,
 * }} args
 * @returns {{ basePwccIls: number, usedCompose: boolean }}
 */
export function resolveVpFixedMarkupBasePwccIls({
  summedRoomPwccIls,
  composedPwccIls,
  slotsLength,
  includedCount,
  hasManualAddedRooms = false,
}) {
  const slots = Math.max(0, Math.floor(Number(slotsLength) || 0));
  const included = Math.max(0, Math.floor(Number(includedCount) || 0));
  const summed = Number(summedRoomPwccIls);
  const composed = Number(composedPwccIls);
  const selectionIncomplete =
    !hasManualAddedRooms && slots > 1 && included < slots;

  const round2 = (n) => Math.round(Number(n) * 100) / 100;

  if (selectionIncomplete && Number.isFinite(composed) && composed > 0) {
    return { basePwccIls: round2(composed), usedCompose: true };
  }

  return {
    basePwccIls: Number.isFinite(summed) && summed > 0 ? round2(summed) : 0,
    usedCompose: false,
  };
}
